import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import "../Pages/Css/reporteservicio.css";
import StaticMap from "./Staticmap";
import StaticMapRecorrido from "./Staticmaprecorrido";
import { formattedGlobalDate } from "../utils/formattedDates";
import StaticsMapsRecorrido2 from "./StaticsMapsRecorrido2";
import StaticMaps2 from "./StaticMaps2";

const LOGOS_CONFIG = [
    { file: "logo-logiseguridad.png", width: 300 },
    { file: "logo_essentia.png", width: 200 },
    { file: "logo_yara.png", width: 100 },
    { file: "logopequenotrans.gif", width: 300 },
    { file: "logo_tmi.webp", width: 200 },
    { file: "logo_summit.png", width: 200 },
    { file: "logo_mexichem.png", width: 200 },
    { file: "logo-cliente-x.png", width: 180 },
];

const COMPANY_LOGO_MAP = {
    logiseguridad: "logo-logiseguridad.png",
    esenttia: "logo_essentia.png",
    essentia: "logo_essentia.png",
    yara: "logo_yara.png",
    pequenotrans: "logopequenotrans.gif",
    tmi: "logo_tmi.webp",
    summit: "logo_summit.png",
    mexichem: "logo_mexichem.png",
};

const PRIVATE_ENDPOINTS = {
    getFotos: "/reportes/fotos-contrato",
    getReportestrafico: "/reportes/reportes-trafico",
    getInfoAditionalContrato: "/reportes/visual-logistic",
    getReportesdevice: "/reportes/reportes-device",
    getReportesdeviceValitronics: "/reportes/device-valitronics",
    getInfoContrato:"/reportes/contrato-unico",
};

const PRIVATE_BASE_URL = `https://alertas.cargotronics.com/api`;
const publicAxios = axios.create({
    withCredentials: true,
    timeout: 20000,
});

const getFirstDefinedValue = (...values) => values.find(
    (value) => value !== undefined && value !== null && value !== ""
);

const normalizeContractInfo = (baseContract = {}, tokenPayload = null) => {
    const payload = Array.isArray(tokenPayload) ? tokenPayload[0] || {} : tokenPayload || {};
    const rawPos = String(getFirstDefinedValue(payload.pos, payload.Pos, baseContract.pos, "") || "");
    const [posLat, posLng] = rawPos.split(",").map((value) => Number(String(value || "").trim()));

    return {
        ...baseContract,
        ...payload,
        ContractID: getFirstDefinedValue(
            payload.ContractID,
            payload.Contrato,
            payload.contractId,
            baseContract.ContractID,
            baseContract.Contrato
        ) || "",
        NombreEmpresa: getFirstDefinedValue(
            payload.NombreEmpresa,
            payload.Cliente,
            payload.Empresa,
            payload.RazonSocial,
            payload.cliente,
            baseContract.NombreEmpresa
        ) || "",
        DescripcionRuta: getFirstDefinedValue(
            payload.DescripcionRuta,
            payload.Ruta,
            payload.ruta,
            baseContract.DescripcionRuta
        ) || "",
        FKLokDeviceID: getFirstDefinedValue(
            payload.FKLokDeviceID,
            payload.Dispositivo,
            payload.device,
            baseContract.FKLokDeviceID
        ) || "",
        NombreConductor: getFirstDefinedValue(
            payload.NombreConductor,
            payload.Conductor,
            payload.conductor,
            baseContract.NombreConductor
        ) || "",
        MovilConductor: getFirstDefinedValue(
            payload.MovilConductor,
            payload.Celular,
            payload.Telefono,
            payload.telefono,
            baseContract.MovilConductor
        ) || "",
        PlacaTruck: getFirstDefinedValue(
            payload.PlacaTruck,
            payload.Placa,
            payload.placa,
            baseContract.PlacaTruck
        ) || "",
        PlacaTrailer: getFirstDefinedValue(
            payload.PlacaTrailer,
            payload.PlacaRemolque,
            payload.remolque,
            baseContract.PlacaTrailer
        ) || "",
        NombreTranspo: getFirstDefinedValue(
            payload.NombreTranspo,
            payload.Transportador,
            payload.transportador,
            baseContract.NombreTranspo
        ) || "",
        ContainerNum: getFirstDefinedValue(
            payload.ContainerNum,
            payload.Contenedor,
            payload.contenedor,
            baseContract.ContainerNum
        ) || "",
        Ref: getFirstDefinedValue(
            payload.Ref,
            payload.Referencia,
            payload.referencia,
            baseContract.Ref
        ) || "",
        fecha: getFirstDefinedValue(
            payload.fecha,
            payload.fechainicio,
            payload.FechaInicioServicio,
            payload.InicioServicio,
            payload.ComienzoServicio,
            baseContract.fecha
        ) || "",
        fechafin: getFirstDefinedValue(
            payload.fechafin,
            payload.FechaFinServicio,
            payload.FinalServicio,
            baseContract.fechafin
        ) || "",
        LastMsgLat: getFirstDefinedValue(
            payload.LastMsgLat,
            payload.lastMsgLat,
            payload.Latitud,
            Number.isFinite(posLat) ? posLat : undefined,
            baseContract.LastMsgLat
        ),
        LastMsgLong: getFirstDefinedValue(
            payload.LastMsgLong,
            payload.lastMsgLong,
            payload.Longitud,
            Number.isFinite(posLng) ? posLng : undefined,
            baseContract.LastMsgLong
        ),
        Active: getFirstDefinedValue(
            payload.Active,
            payload.activo,
            payload.active,
            payload.isActive,
            baseContract.Active
        ),
        FKLokTipoEquipo: getFirstDefinedValue(
            payload.FKLokTipoEquipo,
            payload.tipoequipo,
            baseContract.FKLokTipoEquipo
        ),
    };
};

const getScoreColor = (score) => {
    switch (Number(score) || 0) {
        case 1:
            return "green";
        case 2:
            return "yellow";
        default:
            return Number(score) >= 3 ? "red" : "transparent";
    }
};

const ImageOverlay = ({ photo, onClose }) => {
    const [orientation, setOrientation] = useState("horizontal");

    return (
        <div className="overlay" onClick={onClose}>
            <div className="overlay-content" onClick={(event) => event.stopPropagation()}>
                <img
                    src={photo}
                    alt="Overlay"
                    className={orientation}
                    onLoad={(event) => {
                        const { naturalWidth, naturalHeight } = event.target;
                        setOrientation(naturalWidth >= naturalHeight ? "horizontal" : "vertical");
                    }}
                />
            </div>
        </div>
    );
};

export default function ReporteServicioPublico({
    contrato,
    ultPunto = -1,
    contractR = -1,
    setContainerRef,
    onReady,
    endpointOverrides = {},
    publicToken = "",
    mostrarReporte = true,
}) {
    const containerRef = useRef(null);
    const controllersRef = useRef({
        fotos: null,
        info: null,
        device: null,
        trafico: null,
        contratoInfo: null,
    });
    const readyEmittedRef = useRef(false);
    const mountedRef = useRef(false);
    const [imgData, setImgData] = useState({});
    const [infocontrato, setInfocontrato] = useState({});
    const [infocontratoFake, setInfocontratoFake] = useState([]);
    const [fotos, setFotos] = useState([]);
    const [recorrido, setRecorrido] = useState([]);
    const [reportes, setReportes] = useState([]);
    const [comparision, setComparision] = useState([]);
    const [loading, setLoading] = useState(false);
    const [clickedImage, setClickedImage] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
    const logoEmpresa = localStorage.getItem("logoempresa");
    const normalizedPublicToken = String(publicToken || "").trim();

    const endpoints = useMemo(() => ({
        ...PRIVATE_ENDPOINTS,
        ...Object.fromEntries(
            Object.entries(endpointOverrides || {}).filter(([, value]) => Boolean(value))
        ),
    }), [endpointOverrides]);

    const abortController = (key) => {
        controllersRef.current?.[key]?.abort?.();
        controllersRef.current[key] = new AbortController();
        return controllersRef.current[key];
    };

    const getResponsePayload = (response) => {
        if (!response?.data) return null;
        if (response.data.success === false) {
            throw new Error(response.data.message || "La consulta publica no fue exitosa.");
        }
        return response.data.data ?? response.data.info ?? response.data;
    };

    const getArrayPayload = (payload) => {
        if (Array.isArray(payload)) return payload;
        if (Array.isArray(payload?.recordset)) return payload.recordset;
        if (Array.isArray(payload?.recordsets?.[0])) return payload.recordsets[0];
        if (Array.isArray(payload?.data)) return payload.data;
        if (Array.isArray(payload?.info)) return payload.info;
        return [];
    };

    const executePrivateRequest = (endpoint, controller, authorizationValue, body) => publicAxios.post(
        `${PRIVATE_BASE_URL}${endpoint}`,
        body === undefined ? undefined : JSON.stringify(body),
        {
            signal: controller.signal,
            headers: {
                ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
                Authorization: `Bearer ${authorizationValue}`,
            },
            withCredentials: true,
        }
    );

    const postWithToken = async (endpointKey, controller, body) => {
       
        if (!normalizedPublicToken) {
            throw new Error("No hay publicToken disponible para consultar el reporte.");
        }
        console.log(`Consultando endpoint ${endpointKey} con token publico:`, {
            authorizationPreview: `${normalizedPublicToken.slice(0, 12)}...`,
            hasBody: body !== undefined,
        });

        const endpoint = endpoints[endpointKey];
        if (!endpoint) {
            throw new Error(`No se encontro el endpoint para ${endpointKey}.`);
        }

        try {
            return await executePrivateRequest(endpoint, controller, normalizedPublicToken, body);
        } catch (error) {
            console.error(`Error ${endpointKey} con token publico:`, {
                status: error?.response?.status,
                data: error?.response?.data,
                authorizationPreview: `${normalizedPublicToken.slice(0, 12)}...`,
            });
            throw error;
        }
    };

    const waitImages = async (root) => {
        const imgs = Array.from(root?.querySelectorAll?.("img") || []);
        const pending = imgs.filter((img) => !img.complete || img.naturalWidth === 0 || img.naturalHeight === 0);
        if (!pending.length) return;

        await Promise.all(pending.map((img) => new Promise((resolve) => {
            const done = () => resolve();
            img.addEventListener("load", done, { once: true });
            img.addEventListener("error", done, { once: true });
        })));
    };

    const maybeEmitReady = async () => {
        if (readyEmittedRef.current || !containerRef.current) return;

        const dataReady =
            infocontrato?.ContractID &&
            Array.isArray(fotos) &&
            Array.isArray(reportes) &&
            Array.isArray(recorrido) &&
            !loading;

        if (!dataReady) return;

        await waitImages(containerRef.current);
        readyEmittedRef.current = true;
        window.__REPORTE_READY__ = true;
        onReady?.();
    };

    const resolvePhotoSource = (photoData) => photoData?.SourceBase64 || photoData?.Source || "";

    const getInfoFotosReporte = async (events, fotosSource = fotos) => {
        let infoPhoto = [];

        if (typeof events === "object" && !Array.isArray(events)) {
            const eventValues = Object.values(events);
            const isStringEvent = eventValues.every((value) => typeof value === "string");

            if (isStringEvent) {
                infoPhoto = eventValues.map((event) => fotosSource.find((foto) => foto && foto.photo === event));
            } else {
                infoPhoto = Object.keys(events).map((eventKey) => {
                    const event = events[eventKey];
                    return fotosSource.find((foto) => foto && foto.photo === event?.image);
                });
            }
        }

        return infoPhoto.filter(Boolean);
    };

    const processComparison = async (comp, assetID, type, fotosSource = fotos) => {
        const events = comp?.events || {};
        const results = comp?.results || {};
        const fotosInfo = await getInfoFotosReporte(events, fotosSource);

        return {
            id: assetID,
            events,
            results,
            scores: results.scores,
            scoreColor: getScoreColor(results?.scores?.status),
            fotosInfo,
            type,
        };
    };

    const getInfoAditionalContrato = async (fotosSource = fotos) => {
        if (!normalizedPublicToken) return;

        try {
            const controller = abortController("info");
            const response = await postWithToken("getInfoAditionalContrato", controller);
            console.log("InfoAditionalContrato response:", response);
            const payload = getResponsePayload(response);

            const assetList = payload?.asset_list || payload?.info?.asset_list || [];
            const assets = Array.isArray(assetList) ? assetList : [assetList];
            const comparisonData = [];

            for (const asset of assets) {
                if (!Array.isArray(asset?.comparison) || !asset.comparison.length) continue;

                for (const comp of asset.comparison) {
                    if (asset.type === "Container") {
                        comparisonData.push(await processComparison(comp, asset.ID, "Container", fotosSource));
                    } else if (asset.type === "Seal") {
                        comparisonData.push(await processComparison(comp, asset.ID, "Seal", fotosSource));
                    } else if (asset.type === "Security label") {
                        comparisonData.push(await processComparison(comp, asset.ID, "Security Label", fotosSource));
                    }
                }
            }

            if (!mountedRef.current) return;
            setComparision(comparisonData);
        } catch (error) {
            if (error.name === "AbortError" || error.name === "CanceledError") return;
            console.error("Error al obtener la informacion adicional del contrato:", error);
        }
    };

    const getFotos = async () => {
        if (!normalizedPublicToken) return;

        try {
            const controller = abortController("fotos");
            const response = await postWithToken("getFotos", controller);
            console.log("Fotos response:", response);
            const payload = getResponsePayload(response);

            if (!mountedRef.current) return;
            const fotosData = getArrayPayload(payload);
            setFotos(fotosData);
            await getInfoAditionalContrato(fotosData);
        } catch (error) {
            if (error.name === "AbortError" || error.name === "CanceledError") return;
            console.error("getFotos error:", error);
        }
    };

    const getInfoContrato = async () => {
        if (!normalizedPublicToken) return null;

        try {
            const controller = abortController("contratoInfo");
            const response = await postWithToken("getInfoContrato", controller, {
                contrato: contractR !== -1 && contractR !== undefined ? contractR : contrato?.ContractID,
            });
            console.log("InfoContrato response:", response);
            const payload = getResponsePayload(response);

            const fakeData = Array.isArray(payload) ? payload : payload ? [payload] : [];
            if (!mountedRef.current) return null;
            setInfocontratoFake(fakeData);
            setInfocontrato((currentInfo) => normalizeContractInfo(currentInfo, fakeData));
            return fakeData;
        } catch (error) {
            if (error.name === "AbortError" || error.name === "CanceledError") return null;
            console.error("getInfoContrato error:", error);
            return null;
        }
    };

    const getReportesdevice = async (currentContract = infocontrato, currentFakeData = null) => {
        if (!normalizedPublicToken) return;

        try {
            const controller = abortController("device");
            const isValitronics = currentContract?.FKLokTipoEquipo === 8;

            if (isValitronics) {
                const response = await postWithToken("getReportesdeviceValitronics", controller, {
                    contrato: contractR !== -1 && contractR !== undefined ? contractR : currentContract?.ContractID,
                });
                const payload = getResponsePayload(response);

                if (!mountedRef.current) return;
                setRecorrido(Array.isArray(payload) ? payload : []);
                return;
            }

            const fakeSource = currentFakeData ?? infocontratoFake;
            const fake = Array.isArray(fakeSource) ? fakeSource[0] : fakeSource;
            const useFakeContract = contractR !== -1 && contractR !== undefined && fake;
            const body = useFakeContract
                ? {
                    fechainicio: fake.ComienzoServicio,
                    fechafin: fake.FinalServicio,
                    device: fake.Dispositivo,
                    utcMinutos: 5,
                    tipo: fake.isActive,
                    tipoequipo: fake.FKLokTipoEquipo,
                }
                : {
                    fechainicio: currentContract?.fecha,
                    fechafin: currentContract?.fechafin,
                    device: currentContract?.FKLokDeviceID,
                    utcMinutos: 5,
                    tipo: currentContract?.Active,
                    tipoequipo: currentContract?.FKLokTipoEquipo,
                };

            console.log("Enviando body para getReportesdevice:", body);
            const response = await postWithToken("getReportesdevice", controller, body);
            console.log("Reportesdevice response:", response);
            const payload = getResponsePayload(response);

            if (!mountedRef.current) return;
            setRecorrido(Array.isArray(payload) ? payload : []);
        } catch (error) {
            if (error.name === "AbortError" || error.name === "CanceledError") return;
            console.error("getReportesdevice error:", error);
        }
    };

    const getReportestrafico = async (currentContract = infocontrato) => {
        if (!normalizedPublicToken) return;

        try {
            const controller = abortController("trafico");
            const response = await postWithToken("getReportestrafico", controller, {
                contrato: currentContract?.ContractID,
            });
            const payload = getResponsePayload(response);

            if (!mountedRef.current) return;
            setReportes(Array.isArray(payload) ? payload : []);
        } catch (error) {
            if (error.name === "AbortError" || error.name === "CanceledError") return;
            console.error("getReportestrafico error:", error);
        }
    };

    useEffect(() => {
        mountedRef.current = true;
        setContainerRef?.(containerRef);

        const handleResize = () => setIsSmallScreen(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);

        return () => {
            mountedRef.current = false;
            Object.values(controllersRef.current).forEach((controller) => controller?.abort?.());
            window.removeEventListener("resize", handleResize);
        };
    }, [setContainerRef]);

    useEffect(() => {
        if (!normalizedPublicToken || !mostrarReporte) return;

        let cancelled = false;

        const loadReport = async () => {
            readyEmittedRef.current = false;
            setLoading(true);
            const baseContractInfo = normalizeContractInfo(contrato);
            setInfocontrato(baseContractInfo);
            setFotos([]);
            setRecorrido([]);
            setReportes([]);
            setComparision([]);
            setImgData({});

            try {
                const fakeData = await getInfoContrato();
                if (cancelled) return;

                const effectiveContract = normalizeContractInfo(baseContractInfo, fakeData);
                if (mountedRef.current) {
                    setInfocontrato(effectiveContract);
                }

                await getReportesdevice(effectiveContract, fakeData);
                if (cancelled) return;

                await getFotos();
                if (cancelled) return;

                await getReportestrafico(effectiveContract);
            } finally {
                if (!cancelled && mountedRef.current) {
                    setLoading(false);
                }
            }
        };

        loadReport();

        return () => {
            cancelled = true;
        };
    }, [contrato, mostrarReporte, contractR, normalizedPublicToken]);

    useEffect(() => {
        maybeEmitReady();
    }, [infocontrato, fotos, reportes, recorrido, loading]);

    useEffect(() => {
        const handleEscapeKey = (event) => {
            if (event.key !== "Escape" || !isOpen) return;

            event.preventDefault();
            event.stopPropagation();
            setIsOpen(false);
            setClickedImage(null);
        };

        window.addEventListener("keydown", handleEscapeKey, true);
        return () => {
            window.removeEventListener("keydown", handleEscapeKey, true);
        };
    }, [isOpen]);

    useEffect(() => {
        console.log("Estado del reporte actualizado:", contrato, infocontrato, fotos, reportes, recorrido, comparision);
    }, [contrato, infocontrato, fotos, reportes, recorrido, comparision]);

    const handlePrint = async () => {
        const printContents = containerRef.current?.innerHTML;
        if (!printContents) return;

        const printTitle = `REPORTE DE SERVICIO EN TRANSITO ${infocontrato.ContractID}`;
        const newWindow = window.open("", "_blank");
        if (!newWindow) return;

        const customStyles = `
            @page {
                size: A4 portrait;
                margin: 12mm;
            }
            body {
                font-family: Arial, sans-serif;
                margin: 0;
                padding: 0;
                color: #000;
                background: #fff;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
            #containerFather,
            #contenedor,
            .container {
                width: 100% !important;
                max-width: none !important;
                margin: 0 !important;
                padding: 0 !important;
                box-sizing: border-box;
            }
            .row {
                --bs-gutter-x: 0;
                --bs-gutter-y: 0;
            }
            .titleLabel {
                font-size: 16px;
            }
            .informacionContratoReporte {
                font-size: 12px;
            }
            .informacionContratoReporte .maps {
                margin-top: 50px;
            }
            .informacionContratoReporte .row {
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 10px;
            }
            .informacionContratoReporte .col {
                flex: 1;
                min-width: 150px;
                padding: 5px;
            }
            .informacionContratoReporte .col img {
                width: 100%;
                height: auto;
            }
            .cuadrophotos {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 10px;
                margin-left: 5px;
                margin-top: 20px;
            }
            .cardphoto {
                background-color: #a0b5bf;
                padding: 0;
                margin: 0;
                width: 100%;
                box-sizing: border-box;
            }
            .cardphoto img {
                width: 100%;
                height: 200px;
                object-fit: cover;
            }
            .cardphoto .card-text {
                font-size: 10px;
                color: #000;
            }
            .cardphoto .card-body {
                padding: 0.5rem;
            }
            .comparision {
                display: flex;
                flex-direction: column;
                page-break-before: always;
            }
            .comparision h3 {
                margin-bottom: 40px;
            }
            .infoAditionalBody {
                height: auto;
            }
            .infoAditionalBody p {
                margin-bottom: 0;
                font-size: 10px;
            }
            .comparision .comparisionImgs {
                display: flex;
                flex-direction: row;
                justify-content: space-evenly;
                margin-top: 12px;
            }
            .comparision-item {
                margin-bottom: 20px;
            }
            .cardphotoComparative {
                position: relative;
                display: inline-block;
                width: calc(46% - 10px);
                margin-bottom: 20px;
            }
            .cardphotoComparative img {
                display: block;
                width: 100%;
                height: 200px;
                border-radius: 8px;
            }
            .cardphotoComparative::before,
            .cardphotoComparative::after {
                content: "";
                position: absolute;
                top: 1px;
                left: 1px;
                right: 1px;
                bottom: 1px;
                border: 2px solid;
                border-radius: 8px;
                opacity: 0;
                animation: pulse 2s infinite;
            }
            .cardphotoComparative.border-green::before,
            .cardphotoComparative.border-green::after {
                border-color: green;
            }
            .cardphotoComparative.border-yellow::before,
            .cardphotoComparative.border-yellow::after {
                border-color: yellow;
            }
            .cardphotoComparative.border-red::before,
            .cardphotoComparative.border-red::after {
                border-color: red;
            }
            .cardphotoComparative::before {
                animation-delay: 0s;
            }
            .cardphotoComparative::after {
                animation-delay: 1s;
            }
            .comparision .comparisionResults {
                margin-top: 40px;
                margin-bottom: 30px;
                font-size: 12px;
            }
            .tablePadre {
                border-collapse: collapse;
                page-break-before: always;
            }
            .tablePadre th,
            .tablePadre td {
                border: 1px solid #000;
                padding: 2px;
            }
            button,
            .btn,
            .overlay {
                display: none !important;
            }
            @keyframes pulse {
                0% { opacity: 0.9; transform: scale(1); }
                100% { opacity: 0; transform: scale(1.02); }
            }
        `;

        newWindow.document.write(`
            <html>
                <head>
                    <title>${printTitle}</title>
                    <style>${customStyles}</style>
                </head>
                <body>${printContents}</body>
            </html>
        `);
        newWindow.document.close();
        newWindow.focus();
        newWindow.onafterprint = () => {
            newWindow.close();
        };
        await waitForWindowImages(newWindow);
        newWindow.print();
    };

    const loadFillData = (array) => array.map((data) => (
        <div
            key={data.IDPhoto}
            className="card cardphoto"
            onMouseDown={() => {
                setClickedImage(resolvePhotoSource(data));
                setIsOpen(true);
            }}
            onMouseUp={() => setClickedImage(null)}
        >
            <img src={resolvePhotoSource(data)} className="card-img-top" alt={data.Evento || "Foto reporte"} />
            <div className="card-body">
                <p className="card-text">
                    Evento: {data.Evento}
                    <br />
                    Latitud: {data.Latitud}
                    <br />
                    Longitud: {data.Longitud}
                    <br />
                    Geocerca: {data.Geo}
                    <br />
                    {data.Hora}
                </p>
            </div>
        </div>
    ));

    const loadFillData2 = (array) => array.map((data) => (
        <tr key={data.IdReport} className="trData">
            <td style={{ border: "1px solid #000" }}>{formattedGlobalDate(data.XTime)}</td>
            <td style={{ border: "1px solid #000" }}>{data.TipoAccion}</td>
            <td style={{ border: "1px solid #000" }}>{data.TipoReporte}</td>
            <td style={{ border: "1px solid #000" }}>{data.Ubicacion}</td>
            <td style={{ border: "1px solid #000" }}>{data.Nota}</td>
            <td style={{ border: "1px solid #000" }}>{data.XUser}</td>
        </tr>
    ));

    const normalizedCompanyName = String(
        infocontrato?.NombreEmpresa || contrato?.NombreEmpresa || ""
    ).trim().toLowerCase();
    const mapUltPoint = normalizedPublicToken ? -1 : ultPunto;
    const companyLogoFile = Object.entries(COMPANY_LOGO_MAP).find(([key]) => normalizedCompanyName.includes(key))?.[1];
    const resolvedLogoFile = logoEmpresa || companyLogoFile || "logo-default.png";
    const logoConfig = LOGOS_CONFIG.find((item) => item.file === resolvedLogoFile) || {
        file: resolvedLogoFile,
        width: 200,
    };
    const logoSrc = new URL(`/images/${logoConfig.file}`, window.location.origin).href;

    const waitForWindowImages = async (targetWindow) => {
        const images = Array.from(targetWindow.document.images || []);
        const pending = images.filter((img) => !img.complete);
        if (!pending.length) return;

        await Promise.all(pending.map((img) => new Promise((resolve) => {
            const done = () => resolve();
            img.addEventListener("load", done, { once: true });
            img.addEventListener("error", done, { once: true });
        })));
    };

    const buildImageMetricsKey = (itemId, imageIndex) => `${itemId}-${imageIndex}`;

    return (
        <div id="containerFather" style={{ backgroundColor: "#fff" }}>
            <button type="button" className="btn btn-outline-secondary float-end" onClick={handlePrint}>
                <i className="bx bx-printer me-1" />
                Imprimir
            </button>

            <div className="container" ref={containerRef} id="contenedor" style={{ fontSize: "12px", backgroundColor: "#fff" }}>
                <div className="row py-1">
                    <img
                        id="logo"
                        alt="Logo empresa"
                        src={logoSrc}
                        style={{ width: logoConfig.width, height: "auto" }}
                    />
                </div>

                <div className="row py-3 text-center" style={{ fontSize: "16px", textAlign: "center", marginBottom: "24px", marginTop: "24px" }}>
                    <b>REPORTE DE SERVICIO EN TRANSITO</b>
                </div>

                {isSmallScreen ? (
                    <div>
                        <div className="row py-1">
                            <div className="col"><b>CLIENTE:</b> {infocontrato.NombreEmpresa}</div>
                            <div className="col"><b>COD. SERVICIO:</b> {infocontrato.ContractID}</div>
                        </div>
                        <div className="row py-1">
                            <div className="col"><b>RUTA:</b> {infocontrato.DescripcionRuta}</div>
                            <div className="col"><b>DISPOSITIVO:</b> {infocontrato.FKLokDeviceID}</div>
                        </div>
                        <div className="row py-1">
                            <div className="col"><b>CONDUCTOR:</b> {infocontrato.NombreConductor}</div>
                            <div className="col"><b>CELULAR:</b> {infocontrato.MovilConductor}</div>
                        </div>
                        <div className="row py-1">
                            <div className="col"><b>PLACA CABEZOTE:</b> {infocontrato.PlacaTruck}</div>
                            <div className="col"><b>PLACA REMOLQUE:</b> {infocontrato.PlacaTrailer}</div>
                        </div>
                        <div className="row py-1">
                            <div className="col"><b>TRANSPORTADOR:</b> {infocontrato.NombreTranspo}</div>
                            <div className="col"><b>INICIO SERVICIO:</b> {infocontrato.fecha}</div>
                        </div>
                        <div className="row py-1">
                            <div className="col"><b>CONTENEDOR N°:</b> {infocontrato.ContainerNum}</div>
                            <div className="col"><b>FINAL SERVICIO:</b> {infocontrato.fechafin}</div>
                        </div>
                        <div className="row py-1">
                            <div className="col"><b>REFERENCIA:</b> {infocontrato.Ref}</div>
                        </div>
                        <div className="row py-3 maps">
                            <div className="col">
                                Ultimo Punto
                                <br />
                                {process.env.REACT_APP_SELECTED_MAP === "google"
                                    ? <StaticMap contrato={infocontrato} ultPoint={mapUltPoint} />
                                    : <StaticMaps2 contrato={infocontrato} ultPoint={mapUltPoint} />}
                            </div>
                            <div className="col">
                                Recorrido
                                <br />
                                {process.env.REACT_APP_SELECTED_MAP === "google"
                                    ? <StaticMapRecorrido recorrido={recorrido} ultRecorrido={contractR} />
                                    : <StaticsMapsRecorrido2 recorrido={recorrido} ultRecorrido={contractR} />}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="informacionContratoReporte">
                        <div className="row py-1">
                            <div className="col"><b>CLIENTE:</b></div>
                            <div className="col">{infocontrato.NombreEmpresa}</div>
                            <div className="col"><b>COD. SERVICIO:</b></div>
                            <div className="col">{infocontrato.ContractID}</div>
                        </div>
                        <div className="row py-1">
                            <div className="col"><b>RUTA:</b></div>
                            <div className="col">{infocontrato.DescripcionRuta}</div>
                            <div className="col"><b>DISPOSITIVO:</b></div>
                            <div className="col">{infocontrato.FKLokDeviceID}</div>
                        </div>
                        <div className="row py-1">
                            <div className="col"><b>CONDUCTOR:</b></div>
                            <div className="col">{infocontrato.NombreConductor}</div>
                            <div className="col"><b>CELULAR:</b></div>
                            <div className="col">{infocontrato.MovilConductor}</div>
                        </div>
                        <div className="row py-1">
                            <div className="col"><b>PLACA CABEZOTE:</b></div>
                            <div className="col">{infocontrato.PlacaTruck}</div>
                            <div className="col"><b>PLACA REMOLQUE:</b></div>
                            <div className="col">{infocontrato.PlacaTrailer}</div>
                        </div>
                        <div className="row py-1">
                            <div className="col"><b>TRANSPORTADOR:</b></div>
                            <div className="col">{infocontrato.NombreTranspo}</div>
                            <div className="col"><b>INICIO SERVICIO:</b></div>
                            <div className="col">{infocontrato.fecha}</div>
                        </div>
                        <div className="row py-1">
                            <div className="col"><b>CONTENEDOR N°:</b></div>
                            <div className="col">{infocontrato.ContainerNum}</div>
                            <div className="col"><b>FINAL SERVICIO:</b></div>
                            <div className="col">{infocontrato.fechafin}</div>
                        </div>
                        <div className="row py-1">
                            <div className="col"><b>REFERENCIA:</b></div>
                            <div className="col">{infocontrato.Ref}</div>
                            <div className="col" />
                            <div className="col" />
                        </div>
                        <div className="row py-3 maps">
                            <div className="col">
                                        Ultimo Punto
                                        <br />
                                        {process.env.REACT_APP_SELECTED_MAP === "google"
                                            ? <StaticMap contrato={infocontrato} ultPoint={mapUltPoint} />
                                            : <StaticMaps2 contrato={infocontrato} ultPoint={mapUltPoint} />}
                                    </div>
                            <div className="col">
                                Recorrido
                                <br />
                                {process.env.REACT_APP_SELECTED_MAP === "google"
                                    ? <StaticMapRecorrido recorrido={recorrido} ultRecorrido={contractR} />
                                    : <StaticsMapsRecorrido2 recorrido={recorrido} ultRecorrido={contractR} />}
                            </div>
                        </div>
                    </div>
                )}

                {reportes.length > 0 && (
                    <div className="row py-3 tablaaaa">
                        <table style={{ border: "1px solid #000" }} className="tablePadre">
                            <thead>
                                <tr>
                                    <th style={{ border: "1px solid #000" }}>Fecha/Hora</th>
                                    <th style={{ border: "1px solid #000" }}>Acción</th>
                                    <th style={{ border: "1px solid #000" }}>Estado</th>
                                    <th style={{ border: "1px solid #000" }}>Ubicación</th>
                                    <th style={{ border: "1px solid #000" }}>Observaciones</th>
                                    <th style={{ border: "1px solid #000" }}>Usuario</th>
                                </tr>
                            </thead>
                            <tbody>{loadFillData2(reportes)}</tbody>
                        </table>
                    </div>
                )}

                {loading ? (
                    <div>Loading...</div>
                ) : (
                    comparision.length > 0 && (
                        <div className="row py-3 comparision">
                            <h3>Análisis de seguridad</h3>
                            {comparision.slice().reverse().map((item, index) => (
                                <div key={`${item.id}-${index}`} className="comparision-item">
                                    <div className="comparisionImgs">
                                        {Object.values(item.events).map((photo, idx) => {
                                            const imageMetricsKey = buildImageMetricsKey(item.id, idx);
                                            const imageMetrics = imgData[imageMetricsKey];
                                            const infoPhoto = Array.isArray(item.fotosInfo)
                                                ? item.fotosInfo.find((foto) => foto && foto.photo === (photo.image || photo))
                                                : null;

                                            const imageUrl = typeof photo === "string"
                                                ? resolvePhotoSource(infoPhoto)
                                                : photo?.image
                                                    ? resolvePhotoSource(infoPhoto)
                                                    : null;

                                            if (!imageUrl) return null;

                                            return (
                                                <div
                                                    key={`${item.id}-${idx}`}
                                                    className={`card cardphotoComparative border-${item.scoreColor} ${clickedImage === imageUrl ? "clicked" : ""}`}
                                                    onMouseDown={() => {
                                                        setClickedImage(imageUrl);
                                                        setIsOpen(true);
                                                    }}
                                                    onMouseUp={() => setClickedImage(null)}
                                                    style={{ position: "relative", width: "calc(46% - 10px)" }}
                                                >
                                                    <div style={{ position: "relative", width: "100%" }}>
                                                        <img
                                                            src={imageUrl}
                                                            className="card-img-top"
                                                            alt={`Event ${idx}`}
                                                            onLoad={(event) => {
                                                                const img = event.target;
                                                                setImgData((prev) => ({
                                                                    ...prev,
                                                                    [imageMetricsKey]: {
                                                                        imgWidth: img.clientWidth,
                                                                        imgHeight: img.clientHeight,
                                                                        naturalWidth: img.naturalWidth,
                                                                        naturalHeight: img.naturalHeight,
                                                                    },
                                                                }));
                                                            }}
                                                            style={{ display: "block", width: "100%", height: "250px" }}
                                                        />

                                                        {photo.bounding_box && imageMetrics && (
                                                            <div
                                                                className="bounding-box"
                                                                style={{
                                                                    position: "absolute",
                                                                    top: `${photo.bounding_box.top * imageMetrics.imgHeight}px`,
                                                                    left: `${photo.bounding_box.left * imageMetrics.imgWidth}px`,
                                                                    width: `${photo.bounding_box.width * imageMetrics.imgWidth}px`,
                                                                    height: `${photo.bounding_box.height * imageMetrics.imgHeight}px`,
                                                                    border: "2px solid blue",
                                                                    boxSizing: "border-box",
                                                                    zIndex: 1,
                                                                }}
                                                            />
                                                        )}

                                                        {photo.related_objects && imageMetrics && photo.related_objects.map((relatedObj, relIdx) => (
                                                            <div
                                                                key={`${item.id}-${idx}-${relIdx}`}
                                                                className="related-bounding-box"
                                                                style={{
                                                                    position: "absolute",
                                                                    top: `${relatedObj.boundingBox.top * imageMetrics.imgHeight}px`,
                                                                    left: `${relatedObj.boundingBox.left * imageMetrics.imgWidth}px`,
                                                                    width: `${relatedObj.boundingBox.width * imageMetrics.imgWidth}px`,
                                                                    height: `${relatedObj.boundingBox.height * imageMetrics.imgHeight}px`,
                                                                    border: "2px solid red",
                                                                    boxSizing: "border-box",
                                                                    zIndex: 2,
                                                                }}
                                                            />
                                                        ))}
                                                    </div>

                                                    {infoPhoto && (
                                                        <div className="card-body infoAditionalBody">
                                                            <p className="card-text">ID: {item.id}</p>
                                                            <p className="card-text">Evento: {infoPhoto.Evento}</p>
                                                            <p className="card-text">Fecha/Hora: {infoPhoto.Hora}</p>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>

                                    <div className="comparisionResults">
                                        <h5 className="titleLabel">{item.type} - {item.id}</h5>
                                        {item.results?.status && item.results?.status?.length > 0 && (
                                            <div>
                                                <strong>STATUS: </strong>
                                                {item.scores?.status === 1 ? "✅" : null}
                                                {item.scores?.status === 2 ? "⚠️" : null}
                                                {item.scores?.status >= 3 ? "❌" : null}
                                                <span>{item.results.status}</span>
                                            </div>
                                        )}
                                        {item.results?.alerts && (
                                            <div>
                                                <strong>ALERTAS:</strong>
                                                <div>
                                                    {item.results.alerts.container_closure ? "⚠️" : "✅"}
                                                    <span>{item.results.container_closure}</span>
                                                </div>
                                                <div>
                                                    {item.results.alerts.physical_condition ? "⚠️" : "✅"}
                                                    <span>{item.results.physical_condition}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )
                )}

                <div className="row py-3 cuadrophotos">{loadFillData(fotos)}</div>
            </div>

            {isOpen && clickedImage && ReactDOM.createPortal(
                <ImageOverlay photo={clickedImage} onClose={() => {
                    setIsOpen(false);
                    setClickedImage(null);
                }} />,
                document.body
            )}
        </div>
    );
}
